export default function LessonLabels({ module }) {
  if (!module?.skill) return null;
  
  const labels = [
    { key: "Skill", value: module.skill, color: "bg-blue-50 text-blue-700 border-blue-200" },
    { key: "Outcome", value: module.outcome, color: "bg-green-50 text-green-700 border-green-200" },
    { key: "Category", value: module.category, color: "bg-purple-50 text-purple-700 border-purple-200" },
  ];

  return (
    <div className="flex flex-wrap gap-2 mb-4" data-testid="lesson-labels">
      {labels.map(l => l.value && (
        <span key={l.key} className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium border ${l.color}`}>
          <span className="opacity-60">{l.key}:</span> {l.value}
        </span>
      ))}
    </div>
  );
}
